<div class="ndf-operation-card-summary">
  <div class="ndf-operation-card-summary__header">
    <div class="ndf-operation-card-summary__header__actions">
      <div class="ndf-operation-card-summary__header__labels">
        <div class="d-flex flex-column">
          <div class="d-flex flex-wrap ndf-operation-card-summary__header__labels__header">
            <a
              class="ndf-operation-card-summary__header__labels__id"
              [ngClass]="{
                'cursor-pointer': isHirable || isSalable || isQuotable,
              }"
              [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
              [queryParams]="{ demandId: operation?.derivativeOperationDemandId }">
              #{{ operation?.demandSummary?.sequentialId }}
            </a>
            <div
              *ngIf="operation?.operationStatus"
              class="ndf-operation-card-summary__header__labels__pill me-2">
              {{ operationStatusLabel }}
            </div>
            <div
              *ngIf="operation?.financialStatus"
              class="ndf-operation-card-summary__header__labels__pill me-2">
              {{ financialStatusLabel }}
            </div>
            <div
              *ngIf="operation?.composition"
              class="ndf-operation-card-summary__header__labels__pill me-2">
              {{ compositionLabel }}
            </div>
            <a
              class="ndf-operation-card-summary__header__labels__id"
              [ngClass]="{
                'cursor-pointer': isHirable || isSalable || isQuotable,
              }"
              [routerLink]="['/dashboard/control/derivative-management/derivatives/list']"
              [queryParams]="{ demandId: operation?.derivativeOperationDemandId }"
              [queryParams]="{ filter: operation?.sequentialId }">
              #{{ operation?.sequentialId }}
            </a>
            <a
              *ngIf="operation?.demandSummary?.comexOperation?.sequentialId"
              class="ndf-operation-card-summary__header__labels__id ms-2"
              [ngClass]="{
                'cursor-pointer': isHirable || isSalable || isQuotable,
              }"
              [routerLink]="[
                '/dashboard/comex-operation/v1/details',
                operation?.demandSummary?.comexOperation?.id,
              ]">
              #{{ operation?.demandSummary?.comexOperation?.sequentialId }}
            </a>
            <a
              *ngIf="operation?.demandSummary?.loanOperation?.sequentialId"
              class="ndf-operation-card-summary__header__labels__id ms-2"
              [ngClass]="{
                'cursor-pointer': isHirable || isSalable || isQuotable,
              }"
              [routerLink]="[
                '/dashboard/costs/debt/management/launch-installments',
                operation?.demandSummary?.loanOperation?.id,
              ]">
              #{{ operation?.demandSummary?.loanOperation?.sequentialId }}
            </a>

            <div class="reference-bank-info">
              <span class="reference-bank-text"
                >{{ operation?.demandSummary?.reference }} |
                <app-bank-logo [code]="operation?.financialInstitution?.compensationCode" />
                {{ operation?.financialInstitution?.displayName }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="ndf-operation-card-summary__header__action">
        <ng-container *ngIf="isClosable">
          <p class="mb-0 me-3">
            <b class="pe-2">{{ tk.Management.NdfOperation | t }}:</b
            >{{ operation?.operationDate || '' | vaultDate }}
          </p>
        </ng-container>
        <app-action-menu
          *ngIf="hasActions"
          [items]="actionIcons"
          (sendItemClick)="handleAction($event)">
        </app-action-menu>
        <ng-container *ngIf="isClosable">
          <i
            class="pi"
            [ngClass]="{
              'pi-chevron-circle-down': !isCollapsed,
              'pi-chevron-circle-up': isCollapsed,
            }"
            (click)="toggleCollapse()">
          </i>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="isClosable; else templateIsntClosable">
      <ng-container *ngIf="isCollapsed">
        <div
          class="ndf-operation-card-summary__header__content ndf-operation-card-summary__header__content--border-bottom">
          <div class="ndf-card-summary__header__content__item max-w-200px">
            <p>{{ operation?.company || '' }}</p>
          </div>
          <div *ngIf="!isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfCurrency | t }}</h3>
            <p>{{ currencyLabel }}</p>
          </div>
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfNotional | t }}</h3>
            <p
              [ngClass]="{
                'line-through': operation?.settlementNotional,
              }">
              {{ isSwapStrategy ? 'R$ ' : '' }}{{ operation?.notionalAmount | number: '1.2-2' }}
            </p>
          </div>
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfDueDate | t }}</h3>
            <p
              [ngClass]="{
                'line-through': operation?.settlementDate,
              }">
              {{ operation?.dueAt || '' | vaultDate }}
            </p>
          </div>
          <div
            *ngIf="operation?.settlementDate"
            class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfSettlementDate | t }}</h3>
            <p>{{ operation?.settlementDate || '' | vaultDate }}</p>
          </div>
          <div
            class="ndf-operation-card-summary__header__content__item"
            [ngClass]="{
              'max-w-200px': operation?.reference?.length,
            }">
            <h3>{{ tk.Management.NdfReference | t }}</h3>
            <p>{{ operation?.reference }}</p>
          </div>
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfDateOfOperation | t }}</h3>
            <p>{{ operation?.operationDate || '' | vaultDate }}</p>
          </div>

          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.user | t }}</h3>
            <p>{{ operation?.userName }}</p>
          </div>
        </div>
        <div
          class="ndf-operation-card-summary__header__content pt-4"
          [ngClass]="{
            'ndf-operation-card-summary__header__content--border-bottom': isHirable,
          }">
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfWorkingDays | t }}</h3>
            <p>{{ operation?.businessDaysCount }}</p>
          </div>
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfCalendarDays | t }}</h3>
            <p>{{ operation?.daysCount }}</p>
          </div>
          <div class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfNotional | t }}</h3>
            <p
              [ngClass]="{
                'line-through': operation?.settlementNotional,
              }">
              {{ operation?.notionalAmount | number: '1.2-2' }}
            </p>
          </div>
          <div
            *ngIf="operation?.settlementNotional"
            class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfNotionalSettlement | t }}</h3>
            <p>
              {{ operation?.settlementNotional | number: '1.2-2' }}
            </p>
          </div>
          <div
            *ngIf="
              operation?.operationStrategyType === 'NDFCAP' ||
              operation?.operationStrategyType === 'Callspread' ||
              operation?.operationStrategyType === 'NDFVanilla'
            "
            class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfForward | t }} (BRL/{{ currencyLabel }})</h3>
            <p>
              {{ operation?.forwardRate | number: '1.4-4' }}
            </p>
          </div>
          <div
            *ngIf="operation?.operationStrategyType === 'NDFCAP'"
            class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfCap | t }}</h3>
            <p>
              {{ operation?.capValue | number: '1.4-4' }}
            </p>
          </div>
          <div *ngIf="isCallStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>{{ tk.Management.NdfCap | t }}</h3>
            <p>{{ operation?.strikeBuy | number: '1.4-4' }}</p>
          </div>
          <div
            *ngIf="operation?.operationStrategyType === 'Callspread'"
            class="ndf-operation-card-summary__header__content__item">
            <h3>Strike Venda</h3>
            <p>{{ operation?.strikeSell | number: '1.4-4' }}</p>
          </div>
          <div *ngIf="isCallStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>Prêmio</h3>
            <p>{{ operation?.premium | number: '1.4-4' }}</p>
          </div>

          <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>Indexador ativo</h3>
            <p>{{ getIndexerLabel(operation?.activeIndexer) }}</p>
          </div>
          <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>Indexador passivo</h3>
            <p>{{ getIndexerLabel(operation?.passiveIndexer) }}</p>
          </div>
          <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>Taxa fixa ativa a.a.%</h3>
            <p>{{ operation?.activeFixedRatePerYear | number: '1.2-2' }}%</p>
          </div>
          <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
            <h3>Taxa fixa passiva a.a.%</h3>
            <p>{{ operation?.passiveFixedRatePerYear | number: '1.2-2' }}%</p>
          </div>
          <div
            class="ndf-operation-card-summary__header__content__item"
            style="max-width: 350px; width: 100%">
            <h3>
              {{
                operation?.financialStatus === 'Settled' &&
                (operation?.composition === 'Full' || operation?.composition === 'Partial')
                  ? (tk.Management.NdfSettlementFee | t)
                  : (tk.Management.NdfReferenceExchange | t)
              }}
            </h3>
            <p>
              <span
                *ngIf="
                  operation?.financialStatus === 'Settled' &&
                  (operation?.composition === 'Full' || operation?.composition === 'Partial')
                ">
                {{ operation?.settlementRate | number: '1.4-4' }}
              </span>
              <span
                *ngIf="
                  !(
                    operation?.financialStatus === 'Settled' &&
                    (operation?.composition === 'Full' || operation?.composition === 'Partial')
                  )
                ">
                {{ operation?.referenceExchangeRate | number: '1.4-4' }}
              </span>
            </p>
          </div>
        </div>
        <div *ngIf="isQuotable" class="ndf-operation-card-summary__header__content pt-2">
          <div class="d-flex w-100 d-flex justify-content-end">
            <app-button
              *appHasPermission="operationPermissions.UPDATE_OPERATION_STATUS"
              class="me-2"
              [id]="'to-quote'"
              [type]="'button'"
              [label]="tk.Management.NdfQuote | t"
              (sendButtonClick)="handleCardSummaryAction('toQuote', operation)">
            </app-button>
          </div>
        </div>
        <div *ngIf="isHirable" class="ndf-operation-card-summary__header__content pt-2">
          <div class="d-flex w-100 d-flex justify-content-end">
            <app-button
              *appHasPermission="operationPermissions.UPDATE_OPERATION_STATUS"
              class="me-2"
              [id]="'to-hire'"
              [type]="'button'"
              [label]="tk.Management.NdfToHire | t"
              (sendButtonClick)="handleCardSummaryAction('toHire', operation)">
            </app-button>
          </div>
        </div>
        <div *ngIf="isSalable" class="ndf-operation-card-summary__header__content pt-2">
          <div class="d-flex w-100 d-flex justify-content-end">
            <app-button
              *appHasPermission="operationPermissions.LIQUIDATE_OPERATION_STATUS"
              class="me-2"
              [id]="'to-sale'"
              [type]="'button'"
              [theme]="'white'"
              [icon]="'pi pi-arrow-right-arrow-left'"
              [label]="tk.Management.NdfSettleContract | t"
              (sendButtonClick)="handleCardSummaryAction('toSale', operation)">
            </app-button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #templateIsntClosable>
      <div
        class="ndf-operation-card-summary__header__content ndf-operation-card-summary__header__content--border-bottom">
        <div class="ndf-card-summary__header__content__item max-w-200px">
          <p>{{ operation?.company || '' }}</p>
        </div>
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.Modality | t }}</h3>
          <p>{{ operationStrategyTypeLabel }}</p>
        </div>
        <div *ngIf="!isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfCurrency | t }}</h3>
          <p>{{ !isSwapStrategy ? currencyLabel : '' }}</p>
        </div>
        <!-- <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfValue | t }} ME</h3>
          <p>
            {{ operation?.notionalAmount | number: '1.2-2' }}
          </p>
        </div> -->
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfNotional | t }}</h3>
          <p
            [ngClass]="{
              'line-through': operation?.settlementNotional,
            }">
            {{ isSwapStrategy ? 'R$ ' : '' }}{{ operation?.notionalAmount | number: '1.2-2' }}
          </p>
        </div>
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfDueDate | t }}</h3>
          <p
            [ngClass]="{
              'line-through': operation?.settlementDate,
            }">
            {{ operation?.dueAt || '' | vaultDate }}
          </p>
        </div>
        <div
          *ngIf="operation?.settlementDate"
          class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfSettlementDate | t }}</h3>
          <p>{{ operation?.settlementDate || '' | vaultDate }}</p>
        </div>
        <div
          class="ndf-operation-card-summary__header__content__item"
          [ngClass]="{
            'max-w-200px': operation?.reference?.length,
          }">
          <h3>{{ tk.Management.NdfRemarks | t }}</h3>
          <p>{{ operation?.reference }}</p>
        </div>
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfDateOfOperation | t }}</h3>
          <p>{{ operation?.operationDate || '' | vaultDate }}</p>
        </div>

        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.user | t }}</h3>
          <p>{{ operation?.userName }}</p>
        </div>
      </div>
      <div
        class="ndf-operation-card-summary__header__content pt-4"
        [ngClass]="{
          'ndf-operation-card-summary__header__content--border-bottom': isHirable,
        }">
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfWorkingDays | t }}</h3>
          <p>{{ operation?.businessDaysCount }}</p>
        </div>
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfCalendarDays | t }}</h3>
          <p>{{ operation?.daysCount }}</p>
        </div>

        <div
          *ngIf="operation?.settlementNotional"
          class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfNotionalSettlement | t }}</h3>
          <p>
            {{ operation?.settlementNotional | number: '1.2-2' }}
          </p>
        </div>
        <div
          *ngIf="
            operation?.operationStrategyType === 'NDFCAP' ||
            operation?.operationStrategyType === 'Callspread' ||
            operation?.operationStrategyType === 'NDFVanilla'
          "
          class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfForward | t }} (BRL/{{ currencyLabel }})</h3>
          <p>
            {{ operation?.forwardRate | number: '1.4-4' }}
          </p>
        </div>
        <div
          *ngIf="operation?.operationStrategyType === 'NDFCAP'"
          class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfCap | t }}</h3>
          <p>
            {{ operation?.capValue | number: '1.4-4' }}
          </p>
        </div>
        <div *ngIf="isCallStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Strike Compra</h3>
          <p>{{ operation?.strikeBuy | number: '1.4-4' }}</p>
        </div>
        <div
          *ngIf="operation?.operationStrategyType === 'Callspread'"
          class="ndf-operation-card-summary__header__content__item">
          <h3>Strike Venda</h3>
          <p>{{ operation?.strikeSell | number: '1.4-4' }}</p>
        </div>
        <div *ngIf="isCallStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Prêmio</h3>
          <p>{{ operation?.premium | number: '1.4-4' }}</p>
        </div>

        <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Indexador ativo</h3>
          <p>{{ getIndexerLabel(operation?.activeIndexer) }}</p>
        </div>
        <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Indexador passivo</h3>
          <p>{{ getIndexerLabel(operation?.passiveIndexer) }}</p>
        </div>
        <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Taxa fixa ativa a.a.%</h3>
          <p>{{ operation?.activeFixedRatePerYear | number: '1.2-2' }}%</p>
        </div>
        <div *ngIf="isSwapStrategy" class="ndf-operation-card-summary__header__content__item">
          <h3>Taxa fixa passiva a.a.%</h3>
          <p>{{ operation?.passiveFixedRatePerYear | number: '1.2-2' }}%</p>
        </div>
        <div class="ndf-operation-card-summary__header__content__item">
          <h3>{{ tk.Management.NdfNotionalBrlByReference | t }}</h3>
          <p>
            {{
              (operation?.notionalBRLByForwardRate || operation?.notionalBRLByReferenceRate) ?? null
                | vaultFormatCurrency
            }}
          </p>
        </div>
        <div
          class="ndf-operation-card-summary__header__content__item"
          style="max-width: 350px; width: 100%">
          <h3>
            {{
              operation?.financialStatus === 'Settled' &&
              (operation?.composition === 'Full' || operation?.composition === 'Partial')
                ? (tk.Management.NdfSettlementFee | t)
                : (tk.Management.NdfReferenceExchange | t)
            }}
          </h3>
          <p>
            <span
              *ngIf="
                operation?.financialStatus === 'Settled' &&
                (operation?.composition === 'Full' || operation?.composition === 'Partial')
              ">
              {{ operation?.settlementRate | number: '1.4-4' }}
            </span>
            <span
              *ngIf="
                !(
                  operation?.financialStatus === 'Settled' &&
                  (operation?.composition === 'Full' || operation?.composition === 'Partial')
                )
              ">
              {{ operation?.referenceExchangeRate | number: '1.4-4' }}
            </span>
          </p>
        </div>

        <div
          *ngIf="operation?.settlementDate"
          class="ndf-operation-card-summary__header__content__item">
          <h3>
            {{ tk.Management.NdfGrossAdjustment | t }}
          </h3>
          <p>
            {{ operation?.totalAmountRounded | number: '1.2-2' }}
          </p>
        </div>
        <div
          *ngIf="operation?.settlementDate"
          class="ndf-operation-card-summary__header__content__item">
          <h3>
            {{ tk.Management.NdfIRRF | t }}
          </h3>
          <p>
            {{ operation?.withholdingTaxRounded | number: '1.2-2' }}
          </p>
        </div>
        <div
          *ngIf="operation?.settlementDate"
          class="ndf-operation-card-summary__header__content__item">
          <h3>
            {{ tk.Management.NdfIRToPay | t }}
          </h3>
          <p>
            {{ operation?.incomeTaxPayableRounded | number: '1.2-2' }}
          </p>
        </div>
        <div
          *ngIf="operation?.settlementDate"
          class="ndf-operation-card-summary__header__content__item">
          <h3>
            {{ tk.Management.NdfNetAdjustment | t }}
          </h3>
          <p>
            {{ operation?.netAmountdRounded | number: '1.2-2' }}
          </p>
        </div>
      </div>
      <div *ngIf="isQuotable" class="ndf-operation-card-summary__header__content pt-2">
        <div class="d-flex w-100 d-flex justify-content-end">
          <app-button
            *appHasPermission="operationPermissions.UPDATE_OPERATION_STATUS"
            class="me-2"
            [id]="'to-quote'"
            [type]="'button'"
            [label]="tk.Management.NdfQuote | t"
            (sendButtonClick)="handleCardSummaryAction('toQuote', operation)">
          </app-button>
        </div>
      </div>
      <div
        *ngIf="isHirable && operation?.financialStatus !== 'Reversed'"
        class="ndf-operation-card-summary__header__content pt-2">
        <div class="d-flex w-100 d-flex justify-content-end">
          <app-button
            *appHasPermission="operationPermissions.UPDATE_OPERATION_STATUS"
            class="me-2"
            [id]="'to-hire'"
            [type]="'button'"
            [label]="tk.Management.NdfToHire | t"
            (sendButtonClick)="handleCardSummaryAction('toHire', operation)">
          </app-button>
        </div>
      </div>
      <div
        *ngIf="isSalable; else templateIsntSalable"
        class="ndf-operation-card-summary__header__content pt-2">
        <div class="d-flex w-100 d-flex justify-content-end align-items-center h-fit-content">
          <app-select-cascade
            [placeholder]="(tk.Management.NdfSettleContract | t) || ''"
            [options]="liquidationOptions"
            [selectedOption]="selectedLiquidation"
            (sendSelectedOption)="handleOptionChange($event)"></app-select-cascade>
        </div>
      </div>
      <ng-template #templateIsntSalable>
        <div
          class="d-flex w-100 d-flex justify-content-end"
          *ngIf="
            !isHirable &&
            !isQuotable &&
            isLiquidatable &&
            !!operation?.settlementDate &&
            operation?.financialStatus === 'Settled'
          ">
          <ng-container *appHasPermission="operationPermissions.REVERSE_LIQUIDATE_OPERATION_STATUS">
            <app-button
              [id]="'revert-liquidation'"
              [type]="'button'"
              [theme]="'white'"
              [icon]="'pi pi-undo'"
              [label]="tk.Management.NdfRevertLiquidatedToOpen | t"
              (sendButtonClick)="handleCardSummaryAction('revert-liquidation-to-open', operation)">
            </app-button>
          </ng-container>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
